<script setup lang="ts">
import type { FinanceMetricKey, MetricFormat, MetricValue } from '@metapic-apps/shared'
import { defaultFormatter, FlexComponent, formatLongValue, formatShortValue, formatterProviderKey } from '@metapic-apps/shared'
import { computed, inject } from 'vue'

import { useFinanceMetrics } from '@/api/performance.api'
import { MetricCard } from '@/components/MetricCard'
import { usePerformanceFilter } from '@/lib/hooks/performance-filter.hooks'
type KpiConfig = { key: FinanceMetricKey; label: string; type: MetricFormat }
const KPIS: KpiConfig[] = [
  { key: 'number_of_orders', label: 'Orders', type: 'number' },
  { key: 'order_value', label: 'Order value', type: 'currency' },
  { key: 'avg_order_value', label: 'Average order value', type: 'currency' },
]
const EMPTY_VALUE = '-'
const { formatMoney } = inject(formatterProviderKey, defaultFormatter)
const financeKeys = KPIS.map((kpi) => kpi.key)
const { metricsFilter } = usePerformanceFilter()
const { metricsState } = useFinanceMetrics(metricsFilter, financeKeys)
const amountOf = (value: MetricValue): number | undefined => {
  if (value === null || value === undefined) {
    return undefined
  }
  return typeof value === 'number' ? value : Number(value.amount)
}
const cards = computed(() =>
  KPIS.map((kpi) => {
    const state = metricsState.value[kpi.key]
    const value = state?.metric?.value
    const amount = amountOf(value)
    const options = { emptyValue: EMPTY_VALUE, formatMoney }
    const shortValue = amount === 0 ? '0' : formatShortValue(value, kpi.type, options)
    const longValue = amount === undefined || amount === 0 ? undefined : formatLongValue(value, kpi.type, options)
    return {
      key: kpi.key,
      title: kpi.label,
      value: shortValue,
      longValue: longValue === shortValue ? undefined : longValue,
      loading: state?.isLoading ?? false,
    }
  }),
)
</script>
<template>
  <FlexComponent :gap="16" wrap="wrap">
    <MetricCard
      v-for="card in cards"
      :key="card.key"
      :title="card.title"
      :value="card.value"
      :long-value="card.longValue"
      :loading="card.loading"
      class="orders-metrics__card"
    />
  </FlexComponent>
</template>
<style scoped lang="scss">
.orders-metrics__card {
  flex: 1;
}
</style>
